import {
  Button,
  Checkbox,
  Empty,
  Form,
  Input,
  Modal,
  Popconfirm,
  Spin,
  Tag,
  message
} from "antd";

import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined
} from "@ant-design/icons";

import {
  useEffect,
  useState
} from "react";

import AccountShell
  from "./accountShell";

import {
  createAccountAddress,
  deleteAccountAddress,
  getAccountAddresses,
  setDefaultAccountAddress,
  updateAccountAddress
} from "../../api/account";

export default function Addresses() {
  const [data, setData] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [open, setOpen] =
    useState(false);

  const [editing, setEditing] =
    useState(null);

  const [form] = Form.useForm();

  const load = async () => {
    try {
      setLoading(true);

      const res =
        await getAccountAddresses();

      setData(
        res?.data?.data || []
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const add = () => {
    setEditing(null);
    form.resetFields();
    form.setFieldsValue({
      is_default: false
    });
    setOpen(true);
  };

  const edit = item => {
    setEditing(item);

    form.setFieldsValue({
      ...item,
      is_default:
        Number(item.is_default) === 1
    });

    setOpen(true);
  };

  const save = async values => {
    try {
      if (editing?.address_id) {
        await updateAccountAddress(
          editing.address_id,
          values
        );
      } else {
        await createAccountAddress(
          values
        );
      }

      message.success(
        editing
          ? "Đã cập nhật địa chỉ."
          : "Đã thêm địa chỉ."
      );

      setOpen(false);
      await load();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
        "Không thể lưu địa chỉ."
      );
    }
  };

  const remove = async id => {
    await deleteAccountAddress(id);
    message.success("Đã xóa địa chỉ.");
    await load();
  };

  const makeDefault = async id => {
    await setDefaultAccountAddress(id);
    message.success(
      "Đã đặt địa chỉ mặc định."
    );
    await load();
  };

  return (
    <AccountShell
      title="Địa chỉ nhận hàng"
      description="Quản lý các địa chỉ giao hàng"
      action={
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={add}
        >
          Thêm
        </Button>
      }
    >
      <Spin spinning={loading}>
        {data.length ? (
          <div className="space-y-3">
            {data.map(item => (
              <div
                key={item.address_id}
                className="
                  border
                  border-slate-100
                  rounded-2xl
                  p-4
                "
              >
                <div
                  className="
                    flex
                    justify-between
                    gap-3
                  "
                >
                  <div className="flex-1">
                    <div
                      className="
                        flex
                        gap-2
                        items-center
                        flex-wrap
                      "
                    >
                      <p
                        className="
                          font-bold
                          text-slate-900
                          m-0
                        "
                      >
                        {item.recipient_name}
                      </p>

                      {Number(
                        item.is_default
                      ) === 1 && (
                        <Tag color="blue">
                          Mặc định
                        </Tag>
                      )}
                    </div>

                    <p
                      className="
                        text-[13px]
                        text-slate-500
                        mt-2
                        mb-0
                      "
                    >
                      {item.phone}
                    </p>

                    <p
                      className="
                        text-[13px]
                        text-slate-600
                        mt-1
                        mb-0
                      "
                    >
                      {item.address_detail}
                      {item.ward
                        ? `, ${item.ward}`
                        : ""}
                      {item.province
                        ? `, ${item.province}`
                        : ""}
                    </p>
                  </div>

                  <div>
                    <Button
                      type="text"
                      icon={<EditOutlined />}
                      onClick={() =>
                        edit(item)
                      }
                    />

                    <Popconfirm
                      title="Xóa địa chỉ?"
                      okText="Xóa"
                      cancelText="Hủy"
                      onConfirm={() =>
                        remove(
                          item.address_id
                        )
                      }
                    >
                      <Button
                        danger
                        type="text"
                        icon={<DeleteOutlined />}
                      />
                    </Popconfirm>
                  </div>
                </div>

                {Number(
                  item.is_default
                ) !== 1 && (
                  <button
                    type="button"
                    onClick={() =>
                      makeDefault(
                        item.address_id
                      )
                    }
                    className="
                      border-0
                      bg-transparent
                      text-blue-600
                      font-semibold
                      text-[12px]
                      p-0
                      mt-3
                    "
                  >
                    Đặt làm mặc định
                  </button>
                )}
              </div>
            ))}
          </div>
        ) : (
          <Empty
            description="Bạn chưa lưu địa chỉ"
          />
        )}
      </Spin>


      <Modal
        title={
          editing
            ? "Sửa địa chỉ"
            : "Thêm địa chỉ"
        }
        open={open}
        footer={null}
        onCancel={() =>
          setOpen(false)
        }
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={save}
        >
          <Form.Item
            name="recipient_name"
            label="Họ tên người nhận"
            rules={[
              {
                required: true,
                message:
                  "Vui lòng nhập người nhận"
              }
            ]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            name="phone"
            label="Số điện thoại"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            name="province"
            label="Tỉnh / Thành phố"
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            name="ward"
            label="Phường / Xã"
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            name="address_detail"
            label="Địa chỉ cụ thể"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input.TextArea
              rows={3}
            />
          </Form.Item>

          <Form.Item
            name="is_default"
            valuePropName="checked"
          >
            <Checkbox>
              Đặt làm địa chỉ mặc định
            </Checkbox>
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
          >
            Lưu địa chỉ
          </Button>
        </Form>
      </Modal>
    </AccountShell>
  );
}
